<mh-micro-site
  *ngIf="missionPartner"
  [missionPartner]="missionPartner"
  [viewerAccountType]="AccountType.MISSION_PARTNER"
  [testimonials]="testimonials"
></mh-micro-site>
